(function(){
  var MENU_SELECTOR = '.panel-menu.mobile-main-menu';
  var openByUser = false;

  function qs(sel, root){ return (root || document).querySelector(sel); }
  function qsa(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function openMenu(){
    openByUser = true;
    document.documentElement.classList.add('adams-menu-force-open');
    document.body.classList.add('mm-open');
    var menu = qs(MENU_SELECTOR);
    if(menu){
      menu.classList.add('mmitemopen');
      menu.classList.remove('mmhide');
      menu.setAttribute('aria-hidden','false');
      menu.style.display='block';
      menu.style.visibility='visible';
      menu.style.opacity='1';
      menu.style.position='fixed';
      menu.style.top='0';
      menu.style.left='0';
      menu.style.height='100dvh';
      menu.style.maxHeight='100dvh';
      menu.style.overflowY='auto';
      menu.style.webkitOverflowScrolling='touch';
      menu.style.zIndex='2147483647';
      menu.style.transform='translate3d(0,0,0)';
      menu.style.pointerEvents='auto';
      qsa('a[href]', menu).forEach(function(a){
        a.classList.add('adams-mobile-menu-real-link');
        a.style.pointerEvents='auto';
        a.style.cursor='pointer';
      });
    }
  }

  function closeMenu(){
    openByUser = false;
    document.documentElement.classList.remove('adams-menu-force-open');
    document.body.classList.remove('mm-open');
    qsa(MENU_SELECTOR).forEach(function(menu){
      menu.classList.remove('mmitemopen');
      menu.classList.add('mmhide');
      menu.setAttribute('aria-hidden','true');
      menu.style.display='';
    });
  }

  function isInsideMenu(el){ return !!(el && el.closest && el.closest(MENU_SELECTOR)); }

  document.addEventListener('click', function(e){
    var toggle = e.target && e.target.closest && e.target.closest('.mainmenumob-js, .adams-mobile-menu-button-text');
    if(toggle){
      e.preventDefault();
      e.stopPropagation();
      if(e.stopImmediatePropagation) e.stopImmediatePropagation();
      openMenu();
      return;
    }

    var close = e.target && e.target.closest && e.target.closest('.adams-mobile-menu-close, .mm-close');
    if(close && isInsideMenu(close)){
      e.preventDefault();
      e.stopPropagation();
      closeMenu();
      return;
    }

    var link = e.target && e.target.closest && e.target.closest(MENU_SELECTOR + ' a[href]');
    if(link){
      var href = link.getAttribute('href');
      if(href && href !== '#' && href.indexOf('javascript:') !== 0){
        e.preventDefault();
        e.stopPropagation();
        if(e.stopImmediatePropagation) e.stopImmediatePropagation();
        openByUser = false;
        window.location.href = link.href;
      }
    }
  }, true);

  document.addEventListener('touchmove', function(e){
    if(!openByUser && !document.documentElement.classList.contains('adams-menu-force-open')) return;
    if(isInsideMenu(e.target)){
      e.stopPropagation();
    } else {
      e.preventDefault();
    }
  }, {passive:false, capture:true});

  document.addEventListener('scroll', function(e){
    if(openByUser || document.documentElement.classList.contains('adams-menu-force-open')){
      openMenu();
    }
  }, true);

  var mo = new MutationObserver(function(){
    if(openByUser || document.documentElement.classList.contains('adams-menu-force-open')) openMenu();
  });
  document.addEventListener('DOMContentLoaded', function(){
    var menu = qs(MENU_SELECTOR);
    if(menu) mo.observe(menu, {attributes:true, attributeFilter:['class','style','aria-hidden']});
    qsa(MENU_SELECTOR + ' a[href]').forEach(function(a){ a.classList.add('adams-mobile-menu-real-link'); });
  });
})();
